import {get} from "@/services/api";

const state = {
    attendances: [],
};

const getters = {
    getAttendances: state => state.attendances,
}

const actions = {
    async fetchBySeminarId({commit},id){
        const response = await get(`gamification/attendance/by_lesson/${id}`)
        commit('setAttendances', response.data.items)
    },
    clear({commit}){
        commit('setAttendances',[])
    }
}

const mutations = {
    setAttendances: (state, attendances) => (state.attendances = attendances),
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

